/**
 * @generated SignedSource<<517a7e30c4755f7bd8e6c19f608d25a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomersViewCustomerAccountsQuery$variables = Record<PropertyKey, never>;
export type CustomersViewCustomerAccountsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CustomerAccountList_query">;
};
export type CustomersViewCustomerAccountsQuery = {
  response: CustomersViewCustomerAccountsQuery$data;
  variables: CustomersViewCustomerAccountsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Literal",
    "name": "searchTerm",
    "value": ""
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "CUSTOMER_SINCE_DESC"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomersViewCustomerAccountsQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CustomerAccountList_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CustomersViewCustomerAccountsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "CustomerAccountConnection",
        "kind": "LinkedField",
        "name": "customerAccounts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerAccountEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomerAccount",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customerName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customerNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "customerAccounts(first:100,searchTerm:\"\",sort:\"CUSTOMER_SINCE_DESC\")"
      },
      {
        "alias": null,
        "args": (v0/*: any*/),
        "filters": [
          "searchTerm",
          "sort"
        ],
        "handle": "connection",
        "key": "CustomerAccountList_customerAccounts",
        "kind": "LinkedHandle",
        "name": "customerAccounts"
      }
    ]
  },
  "params": {
    "cacheID": "e0079aae7c41f0198fbed03c29bdfe0e",
    "id": null,
    "metadata": {},
    "name": "CustomersViewCustomerAccountsQuery",
    "operationKind": "query",
    "text": "query CustomersViewCustomerAccountsQuery {\n  ...CustomerAccountList_query\n}\n\nfragment CustomerAccountListItem_customerAccount on CustomerAccount {\n  id\n  customerName\n  customerNumber\n}\n\nfragment CustomerAccountList_query on Query {\n  customerAccounts(first: 100, searchTerm: \"\", sort: CUSTOMER_SINCE_DESC) {\n    totalCount\n    edges {\n      node {\n        ...CustomerAccountListItem_customerAccount\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7e0ff688668b1e13a7bec9f0558f32bd";

export default node;
